import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import moment from 'moment'
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin'
import initInputSpinner from '../../utils/init-input-spinner'
import getFormData from '../../utils/get-form-data'
import initTel from '../../../js-shared/components/tel'
import initFormViewer from '../../utils/init-form-viewer'
import initCopyButtons from '../../utils/initCopyButtons'
import initPdfButtons from '../../utils/init-pdf-buttons'
import initCalendarButtons from '../../utils/init-calendar-buttons'
import initTooltips from '../../utils/init-tooltips'
import BHubCalendar from '../../utils/bhub-calendar.js'
import { getScrollbarWidth } from '../../utils/tools.js'

const i18n = bookingHub
const { sprintf } = wp.i18n

class HotelForm {
  /**
   * @param {jQuery} el
   */
  constructor(el) {
    this.el = el
    this.stepsEl = this.el.find('.bhub-hotel-form__steps')
    this.activeStepEl = null
    this.navEl = this.el.find('.bhub-hotel-form-nav')
    this.daterangeEl = null
    this.getParams = {}
    this.disabledDays = []
    this.formId = el.attr('data-form-id') * 1
    this.bookingId = el.attr('data-booking-id')
    this.hotelSelectionEnabled = el.attr('data-hotel-selection-enabled') === '1'
    this.selectedHotel = el.attr('data-selected-hotel') * 1 || 0
    this.globalResponse = {}
    this.mainArgs = {}
    this.activeStep = this.stepsEl
      .find('[data-step][data-status="active"]')
      .first()
      .attr('data-step')
    this.roomsWrapper = this.el.find('.bhub-hotel-form__rooms')
    this.isotope = null
    this.layoutToggle = this.el.find('.bhub-hotel-form-filter__layout')
    this.sortButton = this.el.find('.bhub-hotel-form-filter__sort')
    this.sortDialog = this.el.find('.bhub-hotel-form-filter__sort-options')
    this.filters = this.el.find('.bhub-hotel-form-filter__filters')
    this.filterToggle = this.el.find('.bhub-hotel-form-filter__toggle')
    this.sortFilter = this.el.find('.bhub-hotel-form-filter__sort-option')
    this.dateHolder = this.el.find('.bhub-hotel-form-info__date-holder > span')
    this.roomsButton = this.el.find('.bhub-hotel-form-info__room-holder')
    this.roomDialog = this.el.find('.bhub-hotel-form-info__dialog--room')
    this.guestButton = this.el.find('.bhub-hotel-form-info__guests-holder')
    this.guestDialog = this.el.find('.bhub-hotel-form-info__dialog--guests')
    this.roomInput = this.el.find('input[name="rooms"]')
    this.adultsInput = this.el.find('input[name="adults"]')
    this.childrenInput = this.el.find('input[name="children"]')
    this.resultEl = this.el.find('.bhub-hotel-form-result')
    this.skeleton = i18n.roomSkeleton
    this.guestsCount = 0
    this.postsCount = this.el.find('.bhub-feed-hotel-room-2').length || 4
    this.skeletonCount = this.postsCount > 0 ? this.postsCount : 2
    this.direction = 'right'
    this.collect = {
      formId: this.formId,
      bookingId: this.bookingId,
      step: this.activeStep,
      hotel: this.selectedHotel,
      room: 1,
      roomCount: 1,
      adults: 1,
      children: 0,
      date: [],
    }
    this.requesting = false
    this.roomParamTriggered = false
    this.bookingType = 'hotel'
    this.datepicker = {}
    this.el[0].bookingHub = this
    this.roomsInit = false
    this.hotelsInit = false

    if (window.bookingHubState === undefined) {
      window.bookingHubState = {}
    }

    window.bookingHubState[this.bookingId] = {
      isReady: false,
    }

    const that = this

    document.addEventListener('DOMContentLoaded', function () {
      that.init()
    })

    this.layoutToggle.on('click', () => {
      this.layoutToggle.find('i').toggleClass('bhub-icons-grid bhub-icons-list')
      this.roomsWrapper.toggleClass('bhub-hotel-form__rooms--list')
      this.roomsWrapper
        .find('.bhub-feed-hotel-room-2')
        .toggleClass('bhub-feed-hotel-room-2--list')

      if (this.isotope) this.isotope.layout()
    })

    this.sortButton.on('click', function () {
      that.sortDialog.toggleClass('bhub-active')
    })

    this.roomsButton.on('click', function () {
      that.roomDialog.toggleClass('bhub-active')
    })

    this.guestButton.on('click', function () {
      that.guestDialog.toggleClass('bhub-active')
    })

    this.sortFilter.on('click', function () {
      if (!that.isotope) return

      const sortValue = $(this).attr('data-sort')
      that.isotope.arrange({ sortBy: sortValue })
      that.sortDialog.removeClass('bhub-active')
    })

    this.filterToggle.on('click', function () {
      that.filters.toggleClass('bhub-active')
      that.filterToggle
        .find('i')
        .toggleClass('bhub-icons-filter bhub-icons-close')
    })

    initInputSpinner(this.roomInput.get(0))
    initInputSpinner(this.adultsInput.get(0))
    initInputSpinner(this.childrenInput.get(0))

    this.roomInput.on(
      'change',
      this.debounce(function () {
        const val = $(this).val()
        that.collect.roomCount = val

        if (that.activeStep === 'rooms') {
          that.request()
        } else if (that.activeStep !== 'hotel') {
          that.filterRequest('rooms').catch(() => {})
        }
      }, 500)
    )

    this.adultsInput.on(
      'change',
      this.debounce(function () {
        const val = $(this).val()
        that.collect.adults = val

        if (that.activeStep === 'rooms') {
          that.request()
        } else if (that.activeStep !== 'hotel') {
          that.filterRequest('adults').catch(() => {})
        }
      }, 500)
    )

    this.childrenInput.on(
      'change',
      this.debounce(function () {
        const val = $(this).val()
        that.collect.children = val

        if (that.activeStep === 'rooms') {
          that.request()
        } else if (that.activeStep !== 'hotel') {
          that.filterRequest('children').catch(() => {})
        }
      }, 500)
    )

    this.roomInput.on('change', function () {
      that.collect.roomCount = $(this).val() * 1
      that.remakeRoomString()
    })

    this.adultsInput.on('change', function () {
      that.collect.adults = $(this).val() * 1
      that.remakeGuestString()
    })

    this.childrenInput.on('change', function () {
      that.collect.children = $(this).val() * 1
      that.remakeGuestString()
    })

    $(document).on('click', function (e) {
      if (
        !$(e.target).closest(that.sortButton).length &&
        $(e.target).closest(that.sortDialog).length === 0
      ) {
        that.sortDialog.removeClass('bhub-active')
      }

      if (
        !$(e.target).closest(that.roomsButton).length &&
        $(e.target).closest(that.roomDialog).length === 0
      ) {
        that.roomDialog.removeClass('bhub-active')
      }

      if (
        !$(e.target).closest(that.guestButton).length &&
        $(e.target).closest(that.guestDialog).length === 0
      ) {
        that.guestDialog.removeClass('bhub-active')
      }

      if (
        !$(e.target).closest(that.filterToggle).length &&
        $(e.target).closest(that.filters).length === 0
      ) {
        that.filters.removeClass('bhub-active')
        that.filterToggle.find('i').removeClass('bhub-icons-close')
        that.filterToggle.find('i').addClass('bhub-icons-filter')
      }
    })

    window.addEventListener('bookingHubStepTransition', ({ detail }) => {
      const { instance } = detail

      if (instance.activeStep !== 'checkout') {
        return
      }

      if (instance.activeStepEl[0].bookingHubDepositPaymentInit) {
        return
      }

      instance.activeStepEl[0].bookingHubDepositPaymentInit = true

      const depositInput = instance.activeStepEl.find(
        'input[name="deposit_selection"]:checked'
      )

      if (!depositInput.prop('disabled')) {
        instance.collect.depositPayment = depositInput.val()
      }

      const toggleDeposit = () => {
        const dueRow = instance.activeStepEl.find('.bhub-payment-field--due')
        const depositRow = instance.activeStepEl.find(
          '.bhub-payment-field--deposit'
        )

        if ('deposit' === instance.collect.depositPayment) {
          depositRow.show()
          dueRow.show()
        }

        if ('full' === instance.collect.depositPayment) {
          depositRow.hide()
          dueRow.hide()
        }
      }

      toggleDeposit()

      instance.activeStepEl.on(
        'change',
        'input[name="deposit_selection"]',
        function () {
          instance.collect.depositPayment = $(this).val()
          toggleDeposit()
        }
      )
    })
  }

  callRoomPopup = (hotel) => {
    const roomId = hotel.attr('data-room') * 1
    this.callDetail(roomId).then((content) => {
      this.initRoomGallery(content)
    })
  }

  selectRoom = (hotelEl, args = { silent: false }) => {
    if ((!hotelEl) instanceof $) {
      hotelEl = this.roomsWrapper.find(
        `.bhub-feed-hotel-room-2[data-room=${hotelEl}]`
      )
    }

    this.roomsWrapper
      .find('.bhub-feed-hotel-room-2')
      .removeClass('bhub-selected')
    const roomId = hotelEl.attr('data-room') * 1
    hotelEl.addClass('bhub-selected')
    this.collect.room = roomId
    this.el.find('[data-button=rooms-next]').prop('disabled', false)

    if (!args.silent) {
      this.resetNextSteps()
    }
  }

  unSelectRoom = () => {
    this.el.find('.bhub-feed-hotel-room-2').removeClass('bhub-selected')
    this.el.find('[data-button=rooms-next]').prop('disabled', true)
    this.collect.room = 0
  }

  remakeRoomString = () => {
    const val = this.collect.roomCount
    this.roomsButton.html(
      `${val} ${val > 1 ? i18n.i18n.rooms : i18n.i18n.room}`
    )
  }

  remakeGuestString = () => {
    const count = (this.guestsCount =
      this.collect.adults * 1 + this.collect.children * 1)

    this.guestButton.html(
      `${count} ${count > 1 ? i18n.i18n.guests : i18n.i18n.guest}`
    )
  }

  resetNextSteps = () => {
    const nextSteps = this.activeStepEl.nextAll()
    nextSteps.remove()
  }

  goStep = (step) => {
    const allSteps = this.stepsEl.find('[data-step]')

    if (step === 'extrasOrCheckout') {
      const extrasStep = this.stepsEl.find('[data-step=extras]')
      if (extrasStep.length) {
        step = 'extras'
      }
    }

    const isStepExists = allSteps.filter(`[data-step=${step}]`).length > 0

    this.collect.step = step
    this.activeStep = step

    if (!isStepExists) {
      this.request()
        .then((data) => {
          this.stepsEl.append(data.template)
          this.goStep(data.activeStep)

          if (data.activeStep === 'checkout') {
            this.initCheckout()
          }

          if (data.activeStep === 'extras') {
            this.initExtra()
          }
        })
        .catch((err) => {
          alert(err)
        })
      return
    }

    allSteps.hide()
    this.activeStepEl = allSteps.filter(`[data-step=${step}]`)
    this.activeStepEl.show()

    this.activeStepEl.removeClass('bhub-fade-in-right bhub-fade-in-left')
    this.activeStepEl.addClass(`bhub-fade-in-${this.direction}`)
    this.el[0].scrollIntoView({ behavior: 'smooth' })

    let currentNavStep = this.navEl.find(`[data-step=${step}]`)

    if (!currentNavStep.length) {
      currentNavStep = this.navEl.find('[data-step=rooms]')
    }

    this.navEl.find(`[data-step]`).attr('data-status', '')

    const prevNavSteps = currentNavStep.prevAll('[data-step]')
    const nextNavSteps = currentNavStep.nextAll('[data-step]')

    prevNavSteps.attr('data-status', 'passed')
    nextNavSteps.attr('data-status', '')

    currentNavStep.attr('data-status', 'active')

    if (step === 'rooms') {
      if (!this.roomsInit) {
        this.initRooms()
      }

      if (this.isotope) {
        this.isotope.layout()
      } else {
        this.initIsotope()
      }

      this.autoSelectRoomFromParams()
    }

    if (step === 'done') {
      this.initSuccess()
    }

    if (step === 'pay') {
      this.el.find('.bhub-hotel-form-info').remove()
    }

    window.dispatchEvent(
      new CustomEvent('bookingHubStepTransition', {
        detail: {
          instance: this,
          mainEl: this.el[0],
          bookingId: this.bookingId,
        },
      })
    )
  }

  extrasOrCheckout = () => {
    this.request()
      .then((data) => {
        this.stepsEl.find(`[data-step=${data.activeStep}]`).remove()
        this.stepsEl.append(data.template)
        this.goStep(data.activeStep)

        if (this.collect.step === 'extras') {
          this.initExtra()
        }

        if (this.collect.step === 'checkout') {
          this.initCheckout()
        }
      })
      .catch((err) => alert(err))
  }

  debounce = (fn, threshold) => {
    let timeout
    threshold = threshold || 100
    return function debounced() {
      clearTimeout(timeout)
      var args = arguments
      var _this = this
      function delayed() {
        fn.apply(_this, args)
      }
      timeout = setTimeout(delayed, threshold)
    }
  }

  async init() {
    const that = this
    this.activeStepEl = this.stepsEl.find(`[data-step=${this.activeStep}]`)
    this.daterangeEl = this.el.find('.bhub-hotel-form-info__daterange')
    this.getParams = this.buildGetParams()
    this.mainArgs = this.el.data('args')

    this.collect.adults = this.getParams.adult_count || 1
    this.collect.children = this.getParams.child_count || 0
    this.collect.room = this.getParams.room || 1
    this.collect.roomCount = this.getParams.room_count || 1
    this.collect.date = this.getParams.date || []
    this.collect.rate = this.getParams.rate || '0'
    this.collect.extra = this.getParams.extra || []

    await this.initDays(this.daterangeEl.data('disabled-days'))

    if (this.hotelSelectionEnabled) {
      this.initHotels()
    }

    this.roomsWrapper.find('.bhub-feed-hotel-room-2').each(function () {
      that.initRoomGallery($(this))
    })

    window.dispatchEvent(
      new CustomEvent('bookingHubStepTransition', {
        detail: {
          instance: this,
          mainEl: this.el[0],
          bookingId: this.bookingId,
          step: this.activeStep,
        },
      })
    )

    if (this.activeStep === 'rooms') {
      await this.initIsotope()
      this.initRooms()
      this.autoSelectRoomFromParams()
    }

    if (this.activeStep === 'extras') {
      await this.initExtra()
      this.autoSelectRoomFromParams()
    }

    if (this.activeStep === 'checkout') {
      this.initCheckout()
      this.autoSelectRoomFromParams()

      if (this.getParams.rate !== undefined) {
        this.collect.step = 'checkout'
        this.request().then((data) => {
          this.stepsEl.find('[data-step=checkout]').remove()
          this.stepsEl.append(data.template)
          this.goStep(data.activeStep)
          if (data.activeStep === 'checkout') {
            this.initCheckout()
          }
        })
      }
    }

    this.el.on('click', 'button[data-go]', function () {
      const direction = $(this).attr('data-direction')
      const go = $(this).attr('data-go')

      that.direction = direction
      that.goStep(go)
    })

    const originalTitle = document.title
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        document.title = i18n.inactiveTabTitle
      } else {
        document.title = originalTitle
      }
    })

    window.bookingHubState.isReady = true
    window.dispatchEvent(new CustomEvent('bookingHubReady'))
  }

  initIsotope = () => {
    if (!this.roomsWrapper.find('.bhub-feed-hotel-room-2').length) {
      return
    }

    imagesLoaded(this.roomsWrapper[0], () => {
      this.isotope = new Isotope(this.roomsWrapper[0], {
        itemSelector: '.bhub-feed-hotel-room-2',
        percentPosition: true,
        masonry: {
          columnWidth: '.bhub-hotel-form__room-sizer',
          horizontalOrder: true,
        },
        getSortData: {
          size: function (itemElem) {
            return itemElem.getAttribute('data-room-size')
          },
          price: function (itemElem) {
            return itemElem.getAttribute('data-price')
          },
        },
        sortAscending: {
          size: false,
          price: true,
        },
      })
    })
  }

  initHotels = () => {
    if (this.hotelsInit) return

    const that = this

    this.stepsEl.on('click', '[data-hotel]', function (event) {
      if ($(event.target).closest('a').length || that.requesting) return

      const hotelEl = $(this)
      const hotelId = hotelEl.attr('data-hotel') * 1
      const previousHotel = that.collect.hotel
      const previousSelected = that.stepsEl.find(
        '.bhub-feed-hotel-2.bhub-selected'
      )

      that.stepsEl.find('.bhub-feed-hotel-2').removeClass('bhub-selected')
      hotelEl.addClass('bhub-selected')
      that.collect.hotel = hotelId
      that.collect.step = 'hotel'

      that
        .request('selectHotel')
        .then((data) => {
          that.selectedHotel = data.selectedHotel
          that.collect.room = data.collect.room
          that.collect.rate = data.collect.rate
          that.collect.extra = data.collect.extra

          if (!data.roomCompatible) {
            delete that.getParams.room
            delete that.getParams.rate
            delete that.getParams.extra
            that.roomParamTriggered = false
          }

          that.refreshCalendarForHotel(data)
          that.goStep(data.activeStep)
        })
        .catch((error) => {
          that.collect.hotel = previousHotel
          hotelEl.removeClass('bhub-selected')
          previousSelected.addClass('bhub-selected')
          alert(error)
        })
    })

    this.hotelsInit = true
  }

  refreshCalendarForHotel = (data) => {
    if (!data.hotelChanged) return

    if (this.datepicker && typeof this.datepicker.destroy === 'function') {
      this.datepicker.destroy()
    }

    this.mainArgs = {
      ...this.mainArgs,
      ...data.globalResponse,
    }
    this.disabledDays = []
    this.initDays(data.disabledDays || [])
  }

  request = (action = '') => {
    if (this.requesting) return

    const that = this

    return new Promise((resolve, reject) => {
      $.ajax({
        url: i18n.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'bhub/templates/form/hotel/middleware',
          _ajax_nonce: i18n.nonce,
          ...this.collect,
          bhubAction: action,
        },
        beforeSend: () => {
          this.stepsEl.bhubBlock()
          this.guestDialog.bhubBlock()
          this.roomDialog.bhubBlock()
          this.requesting = true
          if (this.collect.step === 'rooms') {
            this.unSelectRoom()
            this.roomsWrapper.html('')
            if (this.isotope) {
              this.isotope.destroy()
            }
            const count = this.postsCount > 0 ? this.postsCount : 2
            for (let i = 0; i < count; i++) {
              const append = this.skeleton
              this.roomsWrapper.append(append)
            }
          }
        },
        success: (res) => {
          const { data, success } = res

          if (!success) {
            reject(data.message)
          }

          if (data.redirect) {
            window.location.href = data.redirect
            return
          }

          this.globalResponse = data.globalResponse

          if (data.activeStep === 'rooms') {
            this.initRooms()
            this.roomsWrapper.html(data.template)
            this.roomsWrapper.find('.bhub-feed-hotel-room-2').each(function () {
              that.initRoomGallery($(this))
            })
            this.postsCount = data.postsCount
            this.resultEl.text(data.postsCountText)
            this.el
              .find('[data-button=rooms-next]')
              .prop('disabled', !data.selectedRoomAvailable)

            if (success && this.activeStep === 'rooms') {
              this.initIsotope()
            } else {
              if (this.isotope) {
                this.isotope.destroy()
                this.isotope = null
              }
            }
          }

          if (success) {
            resolve(data)
          }
        },
        complete: () => {
          this.firstLoad = true
          this.requesting = false
          this.stepsEl.bhubUnBlock()
          this.guestDialog.bhubUnBlock()
          this.roomDialog.bhubUnBlock()
        },
      })
    })
  }

  filterRequest = (filter) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: i18n.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'bhub/templates/form/hotel/filter_request',
          _ajax_nonce: i18n.nonce,
          ...this.collect,
        },
        beforeSend: () => {
          this.el.find('.bhub-hotel-summary-fields').bhubBlock()
          this.guestDialog.bhubBlock()
          this.roomDialog.bhubBlock()
        },
        success: (res) => {
          const { data, success } = res

          if (success) {
            this.roomsWrapper.html(data.template)
            this.initIsotope()

            resolve(data)

            if (this.activeStep === 'checkout') {
              this.el
                .find('.bhub-hotel-summary-fields')
                .replaceWith(data.summary)
            }
          } else {
            reject(data)

            let recover = false
            if (data.status === 'not_match') {
              if (confirm(data.message)) {
                this.goStep('rooms')
                this.roomDialog.removeClass('bhub-active')
                this.collect.room = null
                this.unSelectRoom()

                this.roomsWrapper.html(data.template)
                this.postsCount = data.postsCount
                this.initIsotope()
              } else {
                recover = true
              }
            } else {
              alert(data.message)
              recover = true
            }

            if (recover) {
              if (filter === 'rooms') {
                this.roomInput.val(data.oldRoomCount)
                this.collect.roomCount = data.oldRoomCount
                this.remakeRoomString()
              }

              if (filter === 'children') {
                this.childrenInput.val(data.oldChildrenCount)
                this.collect.children = data.oldChildrenCount
                this.remakeGuestString()
              }

              if (filter === 'adults') {
                this.adultsInput.val(data.oldAdultsCount)
                this.collect.adults = data.oldAdultsCount
                this.remakeGuestString()
              }
            } else {
              this.resultEl.text(data.postsCountText)
            }
          }
        },
        complete: () => {
          this.el.find('.bhub-hotel-summary-fields').bhubUnBlock()
          this.guestDialog.bhubUnBlock()
          this.roomDialog.bhubUnBlock()
        },
      })
    })
  }

  buildGetParams = () => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    const params = {}
    for (const [key, value] of urlParams.entries()) {
      params[key] = value
    }

    const result = {}

    Object.keys(params).forEach((key) => {
      const match = key.match(/(.*)\[(\d+)]/)
      let value = params[key]
      if (!isNaN(value)) {
        value = parseInt(value, 10)
      }

      if (match) {
        const prop = match[1]
        const index = parseInt(match[2], 10)
        if (!result[prop]) {
          result[prop] = []
        }
        result[prop][index] = value
      } else {
        result[key] = value
      }
    })

    return result
  }

  removeDuplicatedDates = (arr) => {
    const res = arr.map((date) => date.toLocaleDateString())

    return [...new Set(res)]
  }

  getYmd = (month, year) => {
    const date = new Date()

    date.setFullYear(year, month, 1)

    const formattedYear = date.getFullYear()
    const formattedMonth = ('0' + (date.getMonth() + 1)).slice(-2)
    const formattedDay = '01'

    return formattedYear + '-' + formattedMonth + '-' + formattedDay
  }

  getDisabledDays = (ymd) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: i18n.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'bhub/templates/form/step/get_disabled_days',
          _ajax_nonce: i18n.nonce,
          collect: JSON.stringify(this.collect),
          date: ymd,
        },
        success: (res) => {
          const { data, success } = res

          if (success) {
            resolve(data.disabledDays)
          } else {
            reject(data.message)
          }
        },
      })
    })
  }

  initDays = (initialDisabledDays = []) => {
    const that = this
    const useDisabledDays =
      this.disabledDays.length > 0 ? this.disabledDays : initialDisabledDays
    const formattedDays = useDisabledDays.map((date) => {
      return new Date(date)
    })
    this.disabledDays = useDisabledDays
    const { maxDistance, minAllowedDays, maxAllowedDays } = this.mainArgs
    const maxDate =
      maxDistance > 0
        ? moment().add(maxDistance, 'days').format('YYYY-MM-DD')
        : 0

    this.datepicker = new BHubCalendar(this.daterangeEl[0], {
      range: true,
      toggleSelected: false,
      dynamicRange: false,
      showOtherMonths: false,
      selectOtherMonths: false,
      fixedHeight: true,
      minDate: new Date(),
      maxDate,
      position: 'bottom center',
      autoClose: true,
      minRange: minAllowedDays,
      maxRange: maxAllowedDays,
      nightCounter: true,
      rangeHasDisabledDayTooltipMsg: i18n.i18n.unavailableDay,
      rangeDisabledTooltipMaxLimitMsgSingular: i18n.i18n.maxNightSingular,
      rangeDisabledTooltipMaxLimitMsgPlural: i18n.i18n.maxNightPlural,
      rangeDisabledTooltipMinLimitMsgSingular: i18n.i18n.minNightSingular,
      rangeDisabledTooltipMinLimitMsgPlural: i18n.i18n.minNightPlural,
      nightCounterSingular: i18n.i18n.nightCounterSingular,
      nightCounterPlural: i18n.i18n.nightCounterPlural,
      onSelect: ({ formattedDate, datepicker }) => {
        $(datepicker.$el).trigger('change')
        this.dateHolder.text(this.daterangeEl.val())
        if (formattedDate.length !== 2) return

        const selected = this.removeDuplicatedDates(datepicker.selectedDates)
        if (selected.length < 2) {
          datepicker.clear()
          return
        }

        const pad = (n) => String(n).padStart(2, '0')
        this.collect.date = datepicker.selectedDates.map((d) => {
          return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
        })

        if (this.activeStep === 'rooms') {
          this.request()
        } else if (this.activeStep !== 'hotel') {
          this.filterRequest().catch((data) => {
            if (confirm(data.message)) {
              this.goStep('rooms')
            } else {
              datepicker.selectDate(data.oldDate, { silent: true })
            }
          })
        }
      },
      onRenderCell: ({ date }) => {
        const isDateInFormattedDays = formattedDays.some(
          (disabledDates) =>
            date.toLocaleDateString() === disabledDates.toLocaleDateString()
        )

        if (isDateInFormattedDays) {
          return {
            disabled: true,
          }
        }
      },
      onChangeViewDate: ({ month, year }) => {
        const ymd = that.getYmd(month, year)

        if (this.firstDateSelected) {
          this.getDisabledDays(ymd)
            .then((disabledDays) => {
              this.datepicker.disableDate(disabledDays)
              const setDisabledDays = disabledDays.map((date) => {
                return new Date(date)
              })
              that.disabledDays = setDisabledDays
            })
            .catch((err) => {
              alert(err)
            })
        }
      },
      buttons: [
        {
          content() {
            return i18n.todayStr
          },
          onClick(datepicker) {
            datepicker.setViewDate(new Date())
          },
        },
        {
          content() {
            return i18n.clear
          },
          onClick(datepicker) {
            datepicker.clear({ silent: true })
            datepicker.setViewDate(new Date())
          },
        },
      ],
    })

    if (this.daterangeEl.val()) {
      const dates = this.daterangeEl.val().split(', ')
      this.datepicker.selectDate(dates, { silent: true })
      const formattedDisplay = this.datepicker.selectedDates
        .map((d) => moment(d).format(bookingHub.dateFormat))
        .join(', ')
      this.dateHolder.text(formattedDisplay)
      this.collect.date = dates
      this.firstDateSelected = true
    }
  }

  callDetail = (roomId) => {
    const that = this

    return new Promise((resolve, reject) => {
      $.confirm({
        theme: 'bhub-drawer bhub-room-detail-2-drawer',
        closeIcon: true,
        closeIconClass: 'bhub-icons-close',
        draggable: false,
        backgroundDismiss: true,
        animateFromElement: false,
        animationSpeed: 300,
        animation: 'right',
        closeAnimation: 'right',
        useBootstrap: false,
        content: function () {
          var self = this
          return $.ajax({
            url: i18n.ajaxUrl,
            method: 'POST',
            dataType: 'json',
            data: {
              action: 'bhub_get_room_detail',
              _ajax_nonce: i18n.nonce,
              roomId,
              template: 'hotel_room_detail_2',
              ...that.collect,
            },
          })
            .done(function (response) {
              const content = $(response.data.template)
              self.setContent(content)
              self.setTitle(response.data.title)
              resolve(content)
            })
            .fail(function () {
              self.setContent('Something went wrong.')
              reject()
            })
        },
        buttons: {
          select: {
            text: i18n.i18n.select,
            btnClass: 'bhub-hotel-form-button bhub-tp-stepper-button',
            action: function () {
              const self = this
              const roomEl = that.roomsWrapper.find(
                `.bhub-feed-hotel-room-2[data-room=${roomId}]`
              )

              that.selectRoom(roomEl)

              const selectedRateInputEl = self.$content.find(
                'input[name=rate]:checked'
              )
              if (selectedRateInputEl.length) {
                const priceHtml = selectedRateInputEl
                  .parent()
                  .find('.bhub-rate-selection__title .bhub-price-amount')
                const title = selectedRateInputEl
                  .parent()
                  .find('.bhub-rate-selection__title__text')
                  .text()
                roomEl.find('.bhub-price-amount').replaceWith(priceHtml)
                const existsRateLabel = roomEl.find('.bhub-room-selected-rate')
                if (existsRateLabel.length) {
                  existsRateLabel.text(title)
                } else {
                  roomEl
                    .find('.bhub-feed-hotel-room__footer--right')
                    .append(
                      `<span class="bhub-room-selected-rate">${title}</span>`
                    )
                }
                that.collect.rate = selectedRateInputEl.val()
                const isotope = that.activeStepEl
                  .find('[data-bhub-isotope]')
                  .get(0).isotope
                if (typeof isotope !== 'undefined') {
                  isotope.layout()
                }
              }

              const roomTitle = roomEl
                .find('.bhub-feed-hotel-room-2__title')
                .text()
              const rateTitle = selectedRateInputEl
                .parent()
                .find('.bhub-rate-selection__title__text')
                .text()
              const noticeText = `${roomTitle} / ${rateTitle}`
              bookingHub.notyf.success({
                message: sprintf(i18n.i18n.productSelected, noticeText),
                duration: 5000,
                position: { x: 'left', y: 'bottom' },
              })

              if (i18n.autoNextAfterRoomSelect) {
                self.close()
                that.el.find('[data-button=rooms-next]').trigger('click')
              }
            },
          },
        },
        onContentReady: function () {
          that.initRoomGallery(this.$content.find('.bhub-room-detail-2'))
        },
        onOpenBefore: function () {
          const scWidth = getScrollbarWidth()
          $('body, html').css('overflow', 'hidden')
          $('body').css('padding-right', scWidth + 'px')
        },
        onDestroy: function () {
          $('body, html').css('overflow', '')
          $('body').css('padding-right', '')
        },
      })
    })
  }

  initExtra = () => {
    const that = this
    this.collect.extra = {}
    const extras = {}

    const inputSpinners = this.activeStepEl.find('.bhub-input-spinner__input')
    inputSpinners.each(function () {
      initInputSpinner($(this)[0])
    })

    inputSpinners.on('change', function () {
      const cur = $(this)
      const id = cur.attr('name') * 1
      const value = cur.val() * 1
      if (value > 0) {
        extras[id] = value
      } else {
        delete extras[id]
      }
      that.resetNextSteps()
    })

    const addButtons = this.activeStepEl.find(
      '.bhub-extra-item:not(.bhub-extra-item--multiple-selectable)'
    )

    addButtons.on('click', function () {
      const btn = $(this).find('.bhub-extra-item__add-button')
      btn.toggleClass('bhub-has-remove')
      const extraId = btn.data('product-id') * 1
      if (btn.hasClass('bhub-has-remove')) {
        extras[extraId] = 1
      } else {
        delete extras[extraId]
      }
      that.resetNextSteps()
    })

    if (addButtons.length) {
      addButtons.each(function () {
        const btn = $(this).find('.bhub-extra-item__add-button')

        if (btn.hasClass('bhub-has-remove')) {
          const extraId = btn.data('product-id') * 1
          extras[extraId] = 1
        }
      })
    }

    if (inputSpinners.length) {
      inputSpinners.trigger('change')
    }

    that.collect.extra = extras
  }

  initCheckout = () => {
    const that = this

    this.collect.paymentMethod = this.activeStepEl
      .find('input[name=bhub_payment_method]')
      .first()
      .val()

    this.el.on('change', 'input[name=bhub_payment_method]', function () {
      const value = $(this).val()
      that.collect.paymentMethod = value
      that.filterRequest('payment_method')

      const depositSelection = that.activeStepEl.find(
        '.bhub-deposit-payment-selection'
      )
      if (!depositSelection.length) return

      const isLocal = value === 'local'
      const depositInputs = depositSelection.find(
        'input[name="deposit_selection"]'
      )

      depositSelection.toggleClass('bhub-disabled', isLocal)
      depositInputs.prop('disabled', isLocal)

      if (isLocal) {
        depositSelection
          .find('input[name="deposit_selection"][value="full"]')
          .prop('checked', true)
        that.collect.depositPayment = 'full'
      } else {
        const checked = depositSelection.find(
          'input[name="deposit_selection"]:checked'
        )
        that.collect.depositPayment = checked.val()
      }
    })

    this.submitButtonEl = this.activeStepEl.find('[data-button=submit]')

    this.submitButtonEl.on('click', function () {
      that.defaultFormFieldsEl.validate()
      that.formValid = that.defaultFormFieldsEl.valid()
      if (that.customFieldsForm) {
        that.customFieldsForm.submit()
      }
      that.triggerFormValid()

      if (!that.isFormValid()) {
        that.defaultFormFieldsEl.get(0).scrollIntoView({ behavior: 'smooth' })
        return
      }

      that.collect.step = 'done'
      that
        .request()
        .then((data) => {
          that.stepsEl.find('[data-step=pay]').remove()
          that.stepsEl.append(data.template)
          that.goStep(data.activeStep)

          const event = new CustomEvent('bookingHubPaymentStep', {
            detail: {
              mainEl: that.el[0],
              submit: that.submit,
              bookingId: that.bookingId,
              bookingForm: that.collect.formId,
              paymentMethod: that.collect.paymentMethod,
            },
          })

          window.dispatchEvent(event)
        })
        .catch((err) => alert(err))
    })

    this.initFormFields()
    this.initCoupons()
    this.initLogin()
  }

  initLogin = () => {
    const loginButton = this.el.find('[data-button=login]')
    const that = this

    loginButton.on('click', function () {
      $.dialog({
        theme: 'bhub-modal',
        closeIcon: true,
        closeIconClass: 'bhub-icons-close',
        draggable: false,
        backgroundDismiss: true,
        animateFromElement: true,
        animationSpeed: 300,
        animation: 'scale',
        closeAnimation: 'scale',
        columnClass: 'bhub-small bhub-login-modal-form',
        content: function () {
          const self = this
          return $.ajax({
            method: 'POST',
            url: i18n.ajaxUrl,
            data: {
              action: 'bhub_get_login_form',
              _ajax_nonce: i18n.nonce,
              template: 'hotel',
            },
          })
            .done(function (response) {
              self.setTitle(response.data.title)
              self.setContent(response.data.content)
            })
            .fail(function () {
              self.setContent(i18n.wrongMessage)
            })
        },
        onContentReady: function () {
          const modal = this
          const form = this.$content.find('form')
          this.loginFormEl = form
          this.loginFormEl.validate()
          this.loginFormEl.on('submit', function (e) {
            if (!$(this).valid()) return

            e.preventDefault()

            $.ajax({
              method: 'POST',
              url: i18n.ajaxUrl,
              data: $(this).serialize() + '&action=bhub_handle_login_form',
              beforeSend: () => {
                $(this).bhubRemoveAlert()
              },
              success: (res) => {
                if (!res.success) {
                  $(this).bhubAddAlert(res.data.message, 'error')
                } else {
                  i18n.nonce = res.data.loginNonce

                  const defaultForm = that.defaultFormFieldsEl
                  const userData = res.data.userData
                  if (Object.keys(userData).length > 0) {
                    Object.keys(userData).forEach((key) => {
                      const field = defaultForm.find(`[name="${key}"]`)
                      if (field) {
                        field.val(userData[key]).trigger('keyup')
                      }
                    })
                  }

                  that.loginButtonEl.remove()
                  modal.close()
                }
              },
              error: () => {
                $(this).bhubAddAlert(i18n.wrongMessage)
              },
            })
          })
        },
      })
    })
  }

  isFormValid = () => {
    return this.formValid && this.customFieldsValid
  }

  triggerFormValid = () => {
    // const isValid = this.isFormValid()
    // this.submitButtonEl.prop('disabled', !isValid)
  }

  initFormFields = () => {
    const that = this
    const stepEl = this.activeStepEl
    const loginButton = stepEl.find('[data-button=login]')

    const customFields = stepEl.find('.bhub-form-viewer')
    if (customFields.length) {
      initFormViewer(customFields.get(0)).then((form) => {
        this.customFieldsForm = form
        form._state.schema.components.forEach((component) => {
          const isPhone = component?.validate?.validationType === 'phone'
          if (isPhone) {
            const tel = this.activeStepEl.find(`input[id*='${component.id}']`)
            initTel(tel.get(0))
          }
        })
        form.on('changed', (event) => {
          const { data, errors } = event
          this.customFieldsValid = Object.keys(errors).length === 0
          this.triggerFormValid()
          this.collect.customFields = data
        })
      })
    } else {
      this.customFieldsValid = true
      this.collect.customFields = {}
    }

    this.defaultFormFieldsEl = stepEl.find('.bhub-hotel-form-fields')
    this.defaultFormFieldsEl.bhubValidate({
      rules: {
        phone: {
          bhubValidPhone: true,
        },
      },
      onkeyup: function (element) {
        $(element).valid()
      },
      onfocusout: function (element) {
        $(element).valid()
      },
    })

    const tel = this.defaultFormFieldsEl.find('input[type=tel]')
    if (tel.length) {
      initTel(tel.get(0))
    }

    $(tel).on('countrychange', function () {
      that.formValid = that.defaultFormFieldsEl[0].bhubValidate.checkForm()
      that.triggerFormValid()
    })

    this.formValid = this.defaultFormFieldsEl[0].bhubValidate.checkForm()
    this.triggerFormValid()
    this.collect.defaultForm = getFormData(this.defaultFormFieldsEl)

    if (loginButton.length > 0) {
      this.loginButtonEl = loginButton
      this.loginButtonEl.on('click', this.login)
    }

    const handleChange = () => {
      this.formValid = this.defaultFormFieldsEl[0].bhubValidate.checkForm()
      this.triggerFormValid()
      this.collect.defaultForm = getFormData(this.defaultFormFieldsEl)
    }

    this.defaultFormFieldsEl
      .find('input:not([type="checkbox"]), textarea')
      .on('keyup', () => handleChange())

    this.defaultFormFieldsEl.find('input[type=checkbox]').on('change', (e) => {
      $(e.target).valid()
      handleChange()
    })

    this.defaultFormFieldsEl.find('input[type="file"]').on('change', () => {
      handleChange()
    })
  }

  submit = (data = []) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: i18n.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'bhub/templates/form/hotel/submit',
          _ajax_nonce: i18n.nonce,
          collect: JSON.stringify(this.collect),
          data,
        },
        success: (res) => {
          const { data, success } = res

          if (success) {
            this.stepsEl.append(data.template)
            this.collect.activeStep = data.activeStep
            this.goStep(data.activeStep)
            resolve(res.data)
          } else {
            reject(res.data)
          }
        },
      })
    })
  }

  initRooms = () => {
    const that = this
    const roomsStep = this.stepsEl.find('[data-step=rooms]')

    roomsStep.off('click')
    roomsStep.on('click', '[data-room]', function (e) {
      const hotel = $(this)

      if (
        $(e.target).hasClass('bhub-room-detail__prev') ||
        $(e.target).hasClass('bhub-room-detail__next')
      ) {
        return
      }

      if (hotel.hasClass('bhub-selected')) {
        that.unSelectRoom()
        return
      }

      if (hotel.data('rates') !== undefined) {
        that.callRoomPopup(hotel)
        return
      }

      that.selectRoom(hotel)
      if (i18n.autoNextAfterRoomSelect) {
        that.el.find('[data-button=rooms-next]').trigger('click')
      }
    })

    roomsStep.on('click', '.bhub-feed-hotel-room-2__see-detail', function (e) {
      e.stopPropagation()
      const hotel = $(this).closest('.bhub-feed-hotel-room-2')
      that.callRoomPopup(hotel)
    })

    this.roomsInit = true
  }

  autoSelectRoomFromParams = () => {
    if (!this.getParams.room) return
    if (this.getParams.rate !== undefined && !this.hotelSelectionEnabled) return

    if (this.activeStep === 'checkout' || this.activeStep === 'extras') {
      this.goStep('rooms')
      return
    }

    if (this.roomParamTriggered) return
    this.roomParamTriggered = true

    const preSelectedRoom = this.roomsWrapper.find(
      `.bhub-feed-hotel-room-2[data-room=${this.getParams.room}]`
    )
    if (!preSelectedRoom.length) return

    if (
      preSelectedRoom.data('rates') !== undefined &&
      !(this.hotelSelectionEnabled && this.getParams.rate !== undefined)
    ) {
      this.callRoomPopup(preSelectedRoom)
    } else {
      this.selectRoom(preSelectedRoom)
    }
  }

  initRoomGallery = (el) => {
    const galleryWrapper = el.find('.bhub-room-detail__gallery')
    const sliderWrapper = el.find('.bhub-room-detail__section--gallery')

    galleryWrapper.find('a').each(function () {
      // Disable Elementor's lightbox.
      $(this).get(0).dataset.elementorOpenLightbox = 'no'
    })

    const lightbox = new PhotoSwipeLightbox({
      gallery: galleryWrapper.get(0),
      children: 'a',
      pswpModule: PhotoSwipe,
    })

    new PhotoSwipeDynamicCaption(lightbox, {
      type: 'auto',
      captionContent: (slide) => {
        return slide.data.element.getAttribute('data-caption')
      },
    })

    lightbox.init()

    const swiper = new Swiper(sliderWrapper.get(0), {
      modules: [Navigation, Pagination],
      spaceBetween: 15,
      pagination: {
        el: el.find('.bhub-room-detail__pag').get(0),
      },
      navigation: {
        nextEl: el.find('.bhub-room-detail__next').get(0),
        prevEl: el.find('.bhub-room-detail__prev').get(0),
      },
      loop: true,
    })

    lightbox.on('change', () => {
      swiper.slideTo(lightbox.pswp.currIndex)
    })
  }

  refreshTooltips = () => {
    initTooltips(this.el.get(0))
  }

  initSuccess = () => {
    this.el.find('.bhub-hotel-form-info').remove()
    initCopyButtons(this.el.get(0))
    initPdfButtons(this.el.get(0))

    initCalendarButtons(this.el.get(0)).then(() => {
      this.refreshTooltips()
    })
  }

  initCoupons = () => {
    const that = this

    this.el.on('click', '.bhub-coupon-toggle', function (e) {
      e.preventDefault()
      $(this)
        .closest('.bhub-form-field')
        .find('.bhub-coupon-form__wrapper')
        .show()
    })

    this.el.on('click', '.bhub-active-coupons__remove', function (e) {
      e.preventDefault()
      e.stopPropagation()

      $.ajax({
        url: i18n.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          _ajax_nonce: i18n.nonce,
          booking_id: $(this).data('booking-id'),
          collect: JSON.stringify(that.collect),
          action: 'bhub/coupons/remove',
        },
        beforeSend: () => {
          that.el.find('.bhub-coupons').bhubBlock()
        },
        success: (res) => {
          const { data, success } = res

          if (success) {
            that.el.find('.bhub-payment-table').replaceWith(data.paymentTable)
            that.el.find('.bhub-coupons').replaceWith(data.couponTemplate)
            if (data.depositSelection) {
              that.el
                .find('.bhub-deposit-payment-selection')
                .replaceWith(data.depositSelection)
            }
          }
        },
        complete: () => {
          that.el.find('.bhub-coupons').bhubUnBlock()
        },
      })
    })
    // prevent multiple submission
    if (!that.summaryInintedOnce) {
      this.el.on('submit', '.bhub-coupon-form', function (e) {
        e.preventDefault()
        e.stopPropagation()

        $.ajax({
          url: i18n.ajaxUrl,
          method: 'POST',
          dataType: 'json',
          data: [
            $(this).serialize(),
            $.param({
              _ajax_nonce: i18n.nonce,
              collect: JSON.stringify(that.collect),
              action: 'bhub/coupons/add',
            }),
          ].join('&'),
          beforeSend: () => {
            $(this).find('.bhub-coupon-form__error').remove()
            that.el.find('.bhub-coupons').bhubBlock()
            that.summaryInintedOnce = true
          },
          success: (res) => {
            const { data, success } = res

            if (success) {
              that.el.find('.bhub-payment-table').replaceWith(data.paymentTable)
              that.el.find('.bhub-coupons').replaceWith(data.couponTemplate)
              if (data.depositSelection) {
                that.el
                  .find('.bhub-deposit-payment-selection')
                  .replaceWith(data.depositSelection)
              }
              that.refreshTooltips()
            } else {
              $(this).append(
                `<span class="bhub-coupon-form__error">${data.message}</span>`
              )
            }
          },
          complete: () => {
            that.el.find('.bhub-coupons').bhubUnBlock()
          },
        })
      })
    }
  }
}

export default HotelForm
